// import { createSlice } from "@reduxjs/toolkit";

// const savedUser = JSON.parse(localStorage.getItem("userData")) || null;
// const savedBbpsUrls = JSON.parse(localStorage.getItem("bbpsUrls")) || {};

// const authSlice = createSlice({
//   name: "auth",
//   initialState: {
//     user: savedUser,
//     bbpsUrls: savedBbpsUrls, // load persisted URLs
//   },
//   reducers: {
//     setUser: (state, action) => {
//       state.user = action.payload;
//       localStorage.setItem("userData", JSON.stringify(action.payload));
//     },

//     setBbpsUrls: (state, action) => {
//       state.bbpsUrls = action.payload;
//       localStorage.setItem("bbpsUrls", JSON.stringify(action.payload)); // persist URLs
//     },
//     setBbpsUrls: (state, action) => {
//       state.bbpsUrls = action.payload;
//       localStorage.setItem("bbpsUrls", JSON.stringify(action.payload)); // persist URLs
//     },
//     setLoginMeta: (state, action) => {
//       state.loginMeta = action.payload;
//       localStorage.setItem("loginMeta", JSON.stringify(action.payload)); // persist
//     },

//     clearUser: (state) => {
//       state.user = null;
//       state.bbpsUrls = {};
//       localStorage.removeItem("userData");
//       localStorage.removeItem("bbpsUrls");
//       localStorage.removeItem("loginMeta");
//     },
//   },
// });

// export const { setUser, setBbpsUrls, setLoginMeta, clearUser } =
//   authSlice.actions;
// export default authSlice.reducer;

import { createSlice } from "@reduxjs/toolkit";

const savedUser = JSON.parse(localStorage.getItem("userData")) || null;
const savedBbpsUrls = JSON.parse(localStorage.getItem("bbpsUrls")) || {};
const savedLoginMeta = JSON.parse(localStorage.getItem("loginMeta")) || null;
const savedRupayRefNo = sessionStorage.getItem("rupayRefNo");
const savedAccountNo = sessionStorage.getItem("accountNo"); //

const authSlice = createSlice({
  name: "auth",
  initialState: {
    user: savedUser,
    bbpsUrls: savedBbpsUrls,
    loginMeta: savedLoginMeta,
    rupayRefNo: savedRupayRefNo,
    accountNo: savedAccountNo,
    subWallets: [],
  },
  reducers: {
    setUser: (state, action) => {
      state.user = action.payload;
      localStorage.setItem("userData", JSON.stringify(action.payload));
    },

    setRupayRefNo: (state, action) => {
      state.rupayRefNo = action.payload;
      sessionStorage.setItem("rupayRefNo", action.payload);
    },

    // ✅ STORE IN SESSION (TEMPORARY EMERGENCY FIX)
    setAccountNo: (state, action) => {
      state.accountNo = action.payload;
      sessionStorage.setItem("accountNo", action.payload);
    },

    setBbpsUrls: (state, action) => {
      state.bbpsUrls = action.payload;
      localStorage.setItem("bbpsUrls", JSON.stringify(action.payload));
    },

    setLoginMeta: (state, action) => {
      state.loginMeta = action.payload;
      localStorage.setItem("loginMeta", JSON.stringify(action.payload));
    },

    setSubWallets: (state, action) => {
      state.subWallets = action.payload; // small s
    },

    clearUser: (state) => {
      state.user = null;
      state.bbpsUrls = {};
      state.loginMeta = null;
      state.rupayRefNo = null;
      state.accountNo = null;

      localStorage.removeItem("userData");
      localStorage.removeItem("bbpsUrls");
      localStorage.removeItem("loginMeta");
      sessionStorage.removeItem("rupayRefNo");
      sessionStorage.removeItem("accountNo"); // ✅ CLEAR
    },
  },
});

export const {
  setUser,
  setBbpsUrls,
  setLoginMeta,
  clearUser,
  setRupayRefNo,
  setAccountNo,
  setSubWallets   
  
} = authSlice.actions;

export default authSlice.reducer;
